var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMauritania(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c02f27",
    d: "M0 24V0h30v24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ca863",
    d: "M0 6h30v12H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8d749",
    d: "M12.95 9.4h1.56L15 7.92l.49 1.46h1.56l-1.29.94.52 1.49L15 10.9l-1.28.92.52-1.49z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8d749",
    d: "M7.36 8.64c.7 3.48 4.68 5.84 8.9 5.27 3.27-.44 5.84-2.56 6.38-5.27 0 4.1-3.42 7.43-7.64 7.43a7.54 7.54 0 0 1-7.64-7.43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritania);
export default __webpack_public_path__ + "static/media/mauritania.b1e75538ac53aae7d98aeacfe5c1f19b.svg";
export { ForwardRef as ReactComponent };